export const SET_USER = (state, { key, value }) => {
  state._[key].user = value
}

export const SET_NIF = (state, { key, value }) => {
  state._[key].nif = value
}

export const SET_TRADENAME = (state, { key, value }) => {
  state._[key].tradename = value
}

export const ADD = (state, value) => {
  state.list.push(value)
}

export const DELETE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}

export const SET_LIST = (state, value) => {
  state.list = value
}
